import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    container: {
      display: 'flex',
      flexDirection: 'column',
      minHeight: '0',
      height: '100%',

      flex: 1,

      '& > div:first-child': {
        height: '100%',
        minHeight: '0',
        overflowY: 'auto',

        '& > div': {
          height: '100%',
          minHeight: '250px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          overflowY: 'auto',

          '& .MuiTypography-h1, & .MuiTypography-h2': {
            color: theme.palette.text.primary,
            fontWeight: 500,
            fontSize: '2.4rem',
            lineHeight: '35px',
          },
        },
      },

      '& > div:last-child': {
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-end',
        padding: '2rem 0',

        '& > a': {
          width: 'auto',
          height: 'auto',
          margin: '0',
          padding: '1rem 1.5rem',
          minWidth: '10rem',

          '&.Mui-disabled': {
            opacity: 0.6,
            cursor: 'not-allowed',
            background: '#DAD9D9',
            color: '#919190',
            boxShadow: 'none',
          },
        },
      },
    },

    problemIcon: {
      background: theme.palette.error.main,
      width: 60,
      height: 60,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '50%',
      marginBottom: '2rem',

      '& .MuiSvgIcon-root': {
        color: theme.palette.common.white,
        fontSize: 40,
        marginTop: -4,
      },
    },

    successIcon: {
      fontSize: 76,
      color: theme.palette.primary.dark,
      marginBottom: '2rem',
    },
  }),
)
